import React from 'react'

import { AtividadeColetivaGruposFilterForm } from '../componentes/AtividadeColetivaGruposFilterForm'
import { AtividadeColetivaGruposListing } from '../componentes/AtividadeColetivaGruposListing'
import { AtividadeColetivaGruposTable } from '../componentes/AtividadeColetivaGruposTable'
import { useAtividadeColetivaGruposFilter } from './hooks/useAtividadeColetivaGruposFilter'

export function AtividadeColetivaGruposListaView() {
  const { filter, setFilter, convertedFilter, filterTags } = useAtividadeColetivaGruposFilter()

  return (
    <AtividadeColetivaGruposListing
      title='Gestão de grupos de atividade coletiva'
      registerText='Criar novo grupo'
      filter={<AtividadeColetivaGruposFilterForm filter={filter} onChangeFilter={setFilter} />}
      filterTags={filterTags}
    >
      <AtividadeColetivaGruposTable filter={convertedFilter} onChangeFilter={setFilter} />
    </AtividadeColetivaGruposListing>
  )
}
